import React, { useState } from 'react';
import { Button } from '../../../../../../../components/UI';
import SourceItem from './SourceItem';
import styles from './Sources.module.scss';
import { ClientChatSource } from '../../../../../../../store/chat/types';

interface SourcesProps {
  sources: ClientChatSource[];
  inline?: boolean;
  indexOffset?: number;
}

const Sources: React.FC<SourcesProps> = ({ sources, inline = false, indexOffset = 0 }) => {
  const [showContext, setShowContext] = useState(false);

  const toggleContext = () => {
    setShowContext(!showContext);
  };

  if (!sources || sources.length === 0) return null;

  if (inline) {
    // Render all SourceItem components directly, using the correct index
    return (
      <span className={styles.inlineSources}>
        {sources.map((source, i) => (
          <SourceItem key={source.id || i} source={source} index={indexOffset + i} />
        ))}
      </span>
    );
  }

  // Old style: button to show all sources in a popover/list
  return (
    <div>
      <Button variant="ghost" size="small" onClick={toggleContext} className={styles.sourceButton}>
        {showContext ? 'Hide Extra Sources' : 'Show Extra Sources'}
      </Button>

      {showContext && (
        <div className={styles.contextInfo}>
          {sources.map((source, index) => (
            <SourceItem key={index} source={source} index={indexOffset + index} />
          ))}
        </div>
      )}
    </div>
  );
};

export default Sources;
